export const DISABLE_ADDRESS_VALIDATION_KEY = 'DISABLE_ADDRESS_VALIDATION_KEY';

export enum AddressUsedEnum {
  CUSTOM = 'custom',
  SUGGESTED_ORIGINAL = 'suggestedOriginal',
  SUGGESTED_MODIFIED = 'suggestedModified',
}
